/*jshint esversion: 6 */
Redactor.add('plugin', 'video', {
    translations: {
        en: {
            "video": {
                "video": "Video",
                "upload": "Upload",
                "placeholder": "Drag to upload a video<br>or click to select"
            }
        },
        ru: {
            "video": {
                "video": "Видео",
                "upload": "Загрузить",
                "placeholder": "Перетащите видео сюда<br>или нажмите для выбора"
            }
        }
    },
    defaults: {
        context: true,
        upload: false,
        multiple: false,
        name: 'file',
        data: false,
        icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 5C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19H16C16.5523 19 17 18.5523 17 18V15.618L20.4453 17.894C21.1097 18.333 22 17.857 22 17.06V6.94C22 6.143 21.1097 5.667 20.4453 6.106L17 8.382V6C17 5.44772 16.5523 5 16 5H4ZM10.4 9.2C10.0317 8.922 9.5 9.186 9.5 9.65V14.35C9.5 14.814 10.0317 15.078 10.4 14.8L13.5 12.45C13.7667 12.25 13.7667 11.75 13.5 11.55L10.4 9.2Z"/></svg>'
    },
    init() {
        this._pasteAttached = false;
    },
    subscribe: {
        'editor.load': function() {
            this._attachPasteHandler();
        },
        'app.stop': function() {
            this._detachPasteHandler();
        }
    },
    start() {
        if (!this._is()) return;

        let button = {
            title: '## video.video ##',
            icon: this.opts.get('video.icon'),
            command: 'video.popup',
            position: { after: 'image' }
        };

        this.app.toolbar.add('video', button);
        this.app.addbar.add('video', button);

        if (this.opts.is('video.context')) {
            this.app.context.add('video', button);
        }
    },
    popup(e, button) {
        this.app.dropdown.create('video', { width: '280px' });
        this.createUploadTab();
        this.app.dropdown.open(e, button);
    },
    createUploadTab() {
        if (!this.opts.is('video.upload')) return;

        const form = this.app.create('form', {
            name: 'video',
            items: {
                file: this._buildPopupUpload()
            }
        });

        this.app.dropdown.addTab('upload', {
            title: '## video.upload ##',
            form: form
        });
    },
    insertByUpload(response) {
        this.app.dropdown.restoreSelection();
        this.app.dropdown.close();
        this.app.context.close();

        this._insert(response);
    },
    insertByDrop(response, e) {
        if (this.app.block.is()) {
            const insertion = this.app.create('insertion');
            insertion.insertPoint(e);
        }

        this._insert(response);
    },
    drop(e, dt) {
        const files = this._collectVideoFiles(dt);
        if (files.length === 0) return;

        const $block = this.dom(e.target).closest('[data-rx-type]');
        if ($block.length !== 0) {
            this.app.block.set($block);
        }

        this._upload(e, files, 'video.insertByDrop');
    },
    error(response) {
        this.app.broadcast('file.upload.error', { response: response });
    },

    // private
    _is() {
        return this.opts.is('video.upload');
    },
    _isVideoFile(file) {
        return !!(file && typeof file.type === 'string' && file.type.indexOf('video/') === 0);
    },
    _collectVideoFiles(dt) {
        const result = [];
        if (!dt) return result;

        const list = dt.files || [];
        for (let i = 0; i < list.length; i++) {
            const file = list[i] || (dt.items && dt.items[i] && dt.items[i].getAsFile && dt.items[i].getAsFile());
            if (this._isVideoFile(file)) {
                result.push(file);
            }
        }
        return result;
    },
    _upload(e, files, successCallback) {
        if (!this._is()) return;

        const params = {
            url: this.opts.get('video.upload'),
            name: this.opts.get('video.name'),
            data: this.opts.get('video.data'),
            multiple: this.opts.get('video.multiple'),
            success: successCallback,
            error: 'video.error'
        };

        const uploader = this.app.create('uploader', { params: params });
        uploader.send(e, files);
    },
    _insert(response) {
        const normalized = this._normalize(response);
        const entries = Object.entries(normalized);
        if (entries.length === 0) return;

        const insertion = this.app.create('insertion');

        for (const [, item] of entries) {
            if (!item || !item.url) continue;

            const safeUrl = this._escapeAttr(item.url);
            const html = '<p><video controls preload="metadata" style="max-width:100%;" src="'
                + safeUrl + '"></video></p><p></p>';

            insertion.insert({ html: html });
            this.app.broadcast('file.upload', { response: response });
        }
    },
    _normalize(response) {
        const result = {};
        if (!response || typeof response !== 'object' || Array.isArray(response)) return result;
        if (response.error) return result;

        for (const [key, value] of Object.entries(response)) {
            if (value && typeof value === 'object' && !Array.isArray(value) && typeof value.url === 'string') {
                result[key] = value;
            }
        }
        return result;
    },
    _escapeAttr(value) {
        return String(value)
            .replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
    },
    _buildPopupUpload() {
        return {
            type: 'upload',
            upload: {
                type: 'file',
                box: true,
                placeholder: this.lang.get('video.placeholder'),
                url: this.opts.get('video.upload'),
                name: this.opts.get('video.name'),
                data: this.opts.get('video.data'),
                multiple: this.opts.get('video.multiple'),
                success: 'video.insertByUpload',
                error: 'video.error'
            }
        };
    },
    _attachPasteHandler() {
        if (this._pasteAttached || !this._is()) return;

        const $editor = this.app.editor.getEditor();
        const editorEl = $editor && typeof $editor.get === 'function' ? $editor.get() : null;
        if (!editorEl) return;

        this._pasteHandler = (event) => {
            const clipboard = event.clipboardData || (event.originalEvent && event.originalEvent.clipboardData);
            if (!clipboard || !clipboard.items) return;

            const files = [];
            for (let i = 0; i < clipboard.items.length; i++) {
                const it = clipboard.items[i];
                if (it && it.kind === 'file') {
                    const file = it.getAsFile();
                    if (this._isVideoFile(file)) files.push(file);
                }
            }
            if (files.length === 0) return;

            event.preventDefault();
            event.stopPropagation();
            this._upload(event, files, 'video.insertByUpload');
        };

        editorEl.addEventListener('paste', this._pasteHandler, true);
        this._pasteAttached = true;
    },
    _detachPasteHandler() {
        if (!this._pasteAttached) return;

        const $editor = this.app.editor.getEditor();
        const editorEl = $editor && typeof $editor.get === 'function' ? $editor.get() : null;
        if (editorEl && this._pasteHandler) {
            editorEl.removeEventListener('paste', this._pasteHandler, true);
        }
        this._pasteHandler = null;
        this._pasteAttached = false;
    }
});
